module.exports = __webpack_public_path__ + "static/media/Z.1dc84e3b.webp";